import "./financeTollReport.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useEffect, useState } from "react";
import axios from "axios";
import {
  Button,
  CircularProgress,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { NepaliDatePicker } from "nepali-datepicker-reactjs";
import "nepali-datepicker-reactjs/dist/index.css";
import { useSelector } from "react-redux";

const FinanceTollReport = ({ inputs, title }) => {
  const userIdRedux = useSelector((state) => state.user.userId);
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const [tollNameList, setTollNameList] = useState([]);
  const [tollName, setTollName] = useState("");

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(false); // Loading state

  useEffect(() => {
    const fetchTollList = async () => {
      try {
        const res = await axios.get(
          BASE_URL + `/api/tollName/findAllTollName/${userIdRedux}`,
        );
        setTollNameList(res.data);
      } catch (error) {
        console.error("Error fetching toll list:", error);
      }
    };

    if (userIdRedux) {
      fetchTollList();
    }
  }, [userIdRedux]);

  const [errors, setErrors] = useState({});
  const [backEndError, setBackEndError] = useState("");

  const validateForm = () => {
    const errors = {};

    if (!startDate) errors.startDate = "Start Date is required.";
    if (!tollName) errors.tollName = "Toll Name is required.";
    if (!endDate) errors.endDate = "End Date is required.";
    if (!userIdRedux) errors.backEndError = "User ID is NULL. Please re-login.";

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleGenerateReport = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true); // Start loading

    try {
      const response = await axios.get(
        `${BASE_URL}/api/report/generateTollFinanceReport/${userIdRedux}/${startDate}/${endDate}/${tollName}`,
        { responseType: "blob" }, // Handle binary response
      );

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);

      // Create an anchor element and trigger the download
      const a = document.createElement("a");
      a.href = url;
      a.download = "Toll_Finance_Report.pdf";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      if (response.status === 201) {
        setBackEndError(<font color="green">Success Generating Report</font>);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.msg || "There is no data to generate the report.";
      setBackEndError(<span style={{ color: "red" }}>{errorMessage}</span>);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <div className="newUser">
      <Sidebar />
      <div className="newUserContainer">
        <Navbar />
        <div className="top">
          <h1>Toll Finance Report</h1>
        </div>
        <div className="bottom">
          <form
            onSubmit={handleGenerateReport}
            style={{
              display: "grid",
              gap: "1rem",
              width: "100%",
            }}
          >
            <div style={{ display: "flex", gap: "16px" }}>
              <div style={{ flex: 3 }}>
                <InputLabel style={{ flex: 1 }}>Start Date</InputLabel>
                <FormControl
                  style={{ flex: 2 }}
                  margin="normal"
                  error={Boolean(errors.startDate)}
                >
                  <NepaliDatePicker
                    inputClassName="form-control"
                    value={startDate}
                    onChange={(value) => setStartDate(value)}
                    options={{ calenderLocale: "ne", valueLocale: "en" }}
                  />
                  {errors.startDate && (
                    <FormHelperText>{errors.startDate}</FormHelperText>
                  )}
                </FormControl>
              </div>
              <div style={{ flex: 3 }}>
                <InputLabel style={{ flex: 1 }}>End Date</InputLabel>
                <FormControl
                  style={{ flex: 2 }}
                  margin="normal"
                  error={Boolean(errors.endDate)}
                >
                  <NepaliDatePicker
                    inputClassName="form-control"
                    value={endDate}
                    onChange={(value) => setEndDate(value)}
                    options={{ calenderLocale: "ne", valueLocale: "en" }}
                  />
                  {errors.endDate && (
                    <FormHelperText>{errors.endDate}</FormHelperText>
                  )}
                </FormControl>
              </div>

              <label style={{ visibility: "hidden", flex: 6 }}></label>
            </div>

            <div style={{ display: "flex", gap: "16px" }}>
              <FormControl
                style={{ flex: 3 }}
                margin="normal"
                error={Boolean(errors.tollName)}
              >
                <InputLabel>Toll Name</InputLabel>
                <Select
                  name="tollName"
                  value={tollName}
                  onChange={(e) => setTollName(e.target.value)}
                  required
                >
                  {tollNameList.map((toll) => (
                    <MenuItem value={toll.tollName}>{toll.tollName}</MenuItem>
                  ))}
                </Select>
                {errors.tollName && (
                  <FormHelperText>{errors.tollName}</FormHelperText>
                )}
              </FormControl>
              {/* this label is only for occupy some spaces */}
              <label style={{ visibility: "hidden", flex: 9 }}></label>
            </div>

            <Button
              onClick={handleGenerateReport}
              variant="contained"
              color="primary"
              style={{
                borderRadius: "15px",
                width: "25%", // Takes full width
                fontSize: "18px", // Larger font size
                padding: "12px", // Larger padding
              }}
              disabled={loading} // Disable button while loading
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Generate Report"
              )}
            </Button>
            <span className="error-message">{backEndError}</span>
          </form>
        </div>
      </div>
    </div>
  );
};

export default FinanceTollReport;
